export class NICEDigitalTag {
    id: number;
    title = "";
    color = "#000000";
    constructor(niceTag?:any) {
        if (niceTag != null) {
                    this.id = niceTag.id;
                    this.title = niceTag.title;
                    this.color = niceTag.color;                  
            }
        }
}

